<main class="main-wrapper">
    <div class="section" *ngIf="(item.customField19 === 0 || item.customField19 === '0') && item.customField25 == 'vertical'">
        <div class="container-medium">
            <div class="padding-vertical">
                <div class="center-wrapper">
                    <div class="max-width-large">
                        <span class="heading" [class.visible]="showHeading">
                            <calsoft-editor-text [data]="data" [text]="item?.customField15"
                                [fontSize]="item.customField20" [MobfontSize]="item.customField12">
                            </calsoft-editor-text>
                        </span>
                        <span class="description" [class.visible]="showDescription">
                            <calsoft-editor-text [data]="data" [text]="item?.customField17"
                                [fontSize]="item.customField21" [MobfontSize]="item.customField12">
                            </calsoft-editor-text>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="scroll-section vertical-section section" *ngIf="item.customField25 == 'vertical'">
        <div class="wrapper">
            <div role="list" class="list">
                <div role="listitem" class="item" *ngFor="let image of img; let i = index">
                    <div class="item_content">
                        <!-- <h2 class="item_number">{{i + 1}}</h2> -->
                        <h2>
                            <calsoft-editor-text [data]="data" [text]="image?.customField10"
                                [fontSize]="item.customField22" [MobfontSize]="item.customField12">
                            </calsoft-editor-text>
                        </h2>
                        <p class="item_p">
                            <calsoft-editor-text [data]="data" [text]="image?.customField11"
                                [fontSize]="item.customField23" [MobfontSize]="item.customField12">
                            </calsoft-editor-text>
                        </p>
                    </div>
                    <ng-container *ngIf="image.customField6; else imageBlock">
                        <video [src]="serverPath+image.customField6" loading="lazy" autoplay muted loop
                            class="item_media"></video>
                    </ng-container>

                    <ng-template #imageBlock>
                        <img [src]="serverPath+image.customField13" loading="lazy" class="item_media">
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <div class="section" *ngIf="(item.customField19 === 0 || item.customField19 === '0') && item.customField25 == 'horizontal'">
        <div class="container-medium">
            <div class="padding-vertical">
                <div class="center-wrapper">
                    <div class="max-width-large">
                        <span class="heading" [class.visible]="showHeading">
                            <calsoft-editor-text [data]="data" [text]="item?.customField16"
                                [fontSize]="item.customField20" [MobfontSize]="item.customField12">
                            </calsoft-editor-text>
                        </span>
                        <span class="description" [class.visible]="showDescription">
                            <calsoft-editor-text [data]="data" [text]="item?.customField18"
                                [fontSize]="item.customField21" [MobfontSize]="item.customField12">
                            </calsoft-editor-text>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="scroll-section horizontal-section section" *ngIf="item.customField25 == 'horizontal'">
        <div class="wrapper">
            <div role="list" class="list">
                <div role="listitem" class="item" *ngFor="let image of img; let i = index">
                    <div class="item_content">
                        <!-- <h2 class="item_number">{{i + 1}}</h2> -->
                        <h2>
                            <calsoft-editor-text [data]="data" [text]="image?.customField10"
                                [fontSize]="item.customField22" [MobfontSize]="item.customField12">
                            </calsoft-editor-text>
                        </h2>
                        <p class="item_p">
                            <calsoft-editor-text [data]="data" [text]="image?.customField11"
                                [fontSize]="item.customField23" [MobfontSize]="item.customField12">
                            </calsoft-editor-text>
                        </p>
                    </div>
                    <ng-container *ngIf="image.customField6; else imageBlock">
                        <video [src]="serverPath+image.customField6" loading="lazy" autoplay muted loop
                            class="item_media"></video>
                    </ng-container>

                    <ng-template #imageBlock>
                        <img [src]="serverPath+image.customField13" loading="lazy" class="item_media">
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="section">
        <div class="padding-global">
            <div class="container-medium">
                <div class="padding-vertical">
                    <div class="max-width-large">
                        <h1 class="heading">Soo Cool!!</h1>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</main>